import React, { useContext } from "react";
import "../../firm.css";
import "react-phone-input-2/lib/style.css";
import CustomCheckBox from "./CustomCheckBox";
import HeaderFooterImage from "../HeaderFooterImage/HeaderFooterImage";
import { t } from "i18next";
import { ACTIONS, BORDER } from "../../../../constants/Constants";
import { Dropdown, TextField } from "@fluentui/react";
import Select from "react-select";
import themeContext from "../../../../context/theme/ThemeContext";

const dropDownStyle = {
  dropdown: {
    width: "100%",
  },
  dropdownItemSelected: {
    fontSize: "12px",
    lineHeight: "18px",
    fontWeight: "600",
  },
  dropdownItemsWrapper: {
    maxHeight: "300px",
  },
  dropdownItem: {
    fontSize: "12px",
    lineHeight: "18px",
    fontWeight: "600",
    color: "white",
  },
};

const HeaderFileCheck = (props) => {
  const { getThemeColor } = useContext(themeContext);
  const blankLinesOptions = [
    { value: 0, label: 0 },
    { value: 1, label: 1 },
    { value: 2, label: 2 },
    { value: 3, label: 3 },
    { value: 4, label: 4 },
    { value: 5, label: 5 },
  ];

  return (
    <>
      {(props.action === ACTIONS.ADD || props.action === ACTIONS.EDIT) &&
        !props.editConfigurationSetting && (
          <div className="tab-section" style={{}}>
            <p
              style={{
                fontSize: "22px",
                fontWeight: "600",
                marginBottom: "30px",
              }}
            >
              {t("hospital.template-setting")}
            </p>
            <div
              className="form-section-header"
              style={{ marginBottom: "10px" }}
            >
              <span style={{ fontSize: "20px", padding: "5px 0px" }}>
                {props.headerName}
              </span>
            </div>
            <div className="ms-Grid" dir="ltr">
              <div className="ms-Grid-row">
                <CustomCheckBox
                  parentClassName="form-field ms-Grid-col ms-sm12 ms-md8 ms-lg4 ms-xl12"
                  values={props.values.isDOC}
                  label={t("hospital.for-doc")}
                  onChangeCustom={(e, check) => {
                    props.values.isDOC = check;
                  }}
                />
              </div>
              <div className="ms-Grid-row">
              <CustomCheckBox 
                  parentClassName="form-field ms-Grid-col ms-sm12 ms-md8 ms-lg4 ms-xl12"
                  values={props.values.isDOCX}
                  label={t("hospital.for-docx")}
                  onChangeCustom={(e, check) => {
                      props.values.isDOCX = check;
                  }}
              />
            </div>
              <div className="ms-Grid-row">
                <CustomCheckBox
                  parentClassName="form-field ms-Grid-col ms-sm12 ms-md8 ms-lg4 ms-xl12"
                  values={props.values.isPDF}
                  label={t("hospital.for-pdf")}
                  onChangeCustom={(e, check) => {
                    props.values.isPDF = check;
                  }}
                />
              </div>
              <div className="ms-Grid-row">
                <CustomCheckBox
                  parentClassName="form-field ms-Grid-col ms-sm12 ms-md8 ms-lg4 ms-xl12"
                  values={props.values.isPDFWithImage}
                  label={t("hospital.for-pdf-image")}
                  onChangeCustom={(e, check) => {
                    props.values.isPDFWithImage = check;
                  }}
                />
              </div>
              <div className="ms-Grid-row">
                <CustomCheckBox
                  parentClassName="form-field ms-Grid-col ms-sm12 ms-md8 ms-lg4 ms-xl12"
                  values={props.values.isPDFWithKeyImage}
                  label={t("hospital.for-pdf-key-image")}
                  onChangeCustom={(e, check) => {
                    props.values.isPDFWithKeyImage = check;
                  }}
                />
              </div>
              <div className="ms-Grid-row">
                <CustomCheckBox
                  parentClassName="form-field ms-Grid-col ms-sm12 ms-md8 ms-lg4 ms-xl12"
                  values={props.values.isDOCXWithKeyImage}
                  label={t("hospital.for-docx-key-image")}
                  onChangeCustom={(e, check) => {
                    props.values.isDOCXWithKeyImage = check;
                  }}
                />
              </div>
            </div>
            <HeaderFooterImage
              headerName={t("hospital.header-footer-image")}
              values={props.values}
              headerImageValue={props.headerImageValue}
              footerImageValue={props.footerImageValue}
              state={props.state}
              action={props.action}
              ownFirm={props.ownFirm}
              handleClearImage={props.handleClearImage}
              setIsHeaderFileDeleted = {props.setIsHeaderFileDeleted}
              isHeaderFileDeleted = {props.isHeaderFileDeleted}
              setIsFooterFileDeleted = {props.setIsFooterFileDeleted}
              isFooterFileDeleted = {props.isFooterFileDeleted}
              editConfigurationSetting={props.editConfigurationSetting}
              headerImageFileName={props.headerImageFileName}
              setHeaderImageFileName={props.setHeaderImageFileName}
              footerImageFileName={props.footerImageFileName}
              setFooterImageFileName={props.setFooterImageFileName}
            />
            {(props.values.isFirmPacsReceiver || props.values.isFirmPacsReceiver == "true" || process.env.REACT_APP_VDC_PLATFORM == "true") && 
            <div className="ms-Grid" dir="ltr">
              <div className="ms-Grid-row">
                <TextField
                  className="form-field ms-Grid-col ms-sm12 ms-md8 ms-lg4 ms-xl6"
                  label="Custom Header Address Line 1"
                  placeholder="custom header address line 1"
                  name="headerTextLine1"
                  value={props.values?.headerTextLine1}
                  onChange={(e) => {
                    console.log("headerTextLine1-------------on change value----", e.target.value);
                    props.handleChange(e);
                  }}
                />
              </div>
              <div className="ms-Grid-row">
                <TextField
                  className="form-field ms-Grid-col ms-sm12 ms-md8 ms-lg4 ms-xl6"
                  label="Custom Header Address Line 2"
                  placeholder="custom header address line 2"
                  name="headerTextLine2"
                  value={props.values?.headerTextLine2}
                  onChange={(e) => {
                    console.log("headerTextLine2-------------on change value,----", e);
                    props.handleChange(e);
                  }}
                />
              </div>
            </div>
            } 
            <div
              className="ms-Grid-row"
              style={{
                marginTop: "20px",
                display: "flex",
                flexDirection: "column",
                paddingLeft: "15px",
              }}
            >
              <label>No. of Blank Lines Required After Header Image</label>
              <div className="ms-sm12 ms-md10 ms-lg8 ms-xl4">  
                <Select
                  classNamePrefix="react-select"
                  options={blankLinesOptions}
                  defaultValue={{
                    values: props.values.reqBlankLines,
                    label: props.values.reqBlankLines,
                  }}
                  styles={{
                    control: (baseStyles) => ({
                      ...baseStyles,
                      width: "100% !important",
                      color: getThemeColor("primary-color"),
                      backgroundColor: getThemeColor("action-details-background"),
                      border: props.errorState?.country?.error
                        ? "1px solid rgb(164, 38, 44) !important"
                        : getThemeColor("border"),
                    }),
                    menu: (baseStyles, state) => ({
                      ...baseStyles,
                      width: "100% !important",
                      backgroundColor: state.isFocused ? getThemeColor("popup-hover") : getThemeColor("action-details-background"),
                      '&:hover': {
                        backgroundColor: `${getThemeColor("popup-hover")} !important`,
                      },
                    }),
                    menuList: (baseStyles, state) => ({
                      ...baseStyles,
                      backgroundColor: state.isFocused ? getThemeColor("popup-hover") : getThemeColor("action-details-background"),
                      '&:hover': {
                        backgroundColor: `${getThemeColor("popup-hover")} !important`,
                      },
                    }),
                    option: (provided, state) => ({
                      ...provided,
                      fontSize: "14px",
                      lineHeight: "18px",
                      color: getThemeColor("primary-color"),
                      backgroundColor: state.isFocused ? getThemeColor("popup-hover") : getThemeColor("action-details-background"),
                      '&:hover': {
                        backgroundColor: `${getThemeColor("popup-hover")} !important`,
                      },
                    }),  
                  }}
                  onChange={(item) => {
                    props.values.reqBlankLines = item.label;
                  }}
                />
              </div>
              <label style={{marginTop:"9px"}}>No. of Blank Lines Required After Header Report Template</label>
              <div className="ms-sm12 ms-md10 ms-lg8 ms-xl4">  
                <Select
                  name="reqBlankLinesAfterHeader"
                  classNamePrefix="react-select"
                  options={blankLinesOptions}
                  defaultValue={{
                    values: props.values.reqBlankLinesAfterHeader,
                    label: props.values.reqBlankLinesAfterHeader,
                  }}
                  styles={{
                    control: (baseStyles) => ({
                      ...baseStyles,
                      width: "100% !important",
                      color: getThemeColor("primary-color"),
                      backgroundColor: getThemeColor("action-details-background"),
                      border: props.errorState?.country?.error
                        ? "1px solid rgb(164, 38, 44) !important"
                        : getThemeColor("border"),
                    }),
                    menu: (baseStyles, state) => ({
                      ...baseStyles,
                      width: "100% !important",
                      backgroundColor: state.isFocused ? getThemeColor("popup-hover") : getThemeColor("action-details-background"),
                      '&:hover': {
                        backgroundColor: `${getThemeColor("popup-hover")} !important`,
                      },
                    }),
                    menuList: (baseStyles, state) => ({
                      ...baseStyles,
                      backgroundColor: state.isFocused ? getThemeColor("popup-hover") : getThemeColor("action-details-background"),
                      '&:hover': {
                        backgroundColor: `${getThemeColor("popup-hover")} !important`,
                      },
                    }),
                    option: (provided, state) => ({
                      ...provided,
                      fontSize: "14px",
                      lineHeight: "18px",
                      color: getThemeColor("primary-color"),
                      backgroundColor: state.isFocused ? getThemeColor("popup-hover") : getThemeColor("action-details-background"),
                      '&:hover': {
                        backgroundColor: `${getThemeColor("popup-hover")} !important`,
                      },
                    }),  
                  }}
                  onChange={(item) => {
                    props.values.reqBlankLinesAfterHeader = item.label;
                  }}
                />
              </div>
            </div>      
          </div>
        )}
      {(props.action === ACTIONS.VIEW || props.editConfigurationSetting) && (
        <div className="tab-section">
          <p
            style={{
              fontSize: "22px",
              fontWeight: "600",
              padding: "0px 0px",
              marginBottom: "1rem",
            }}
          >
            {t("hospital.template-setting")}
          </p>
          <div className="form-section-header" style={{ marginBottom: "10px" }}>
            <span style={{ fontSize: "18px", padding: "5px 0px" }}>
              {props.headerName}
            </span>
          </div>
          <div className="ms-Grid" dir="ltr">
            <div className="ms-Grid-row">
              <div className="form-field ms-Grid-col ms-sm12 ms-md8 ms-lg3 ms-xl3">
                <div className="form-heading">{t("hospital.for-doc")}</div>
              </div>
              <div className="ms-Grid-col ms-sm12 ms-md6 ms-lg8 ms-xl8">
                {props.values.isDOC == 1
                  ? t("confirm-message.yes")
                  : t("confirm-message.no")}
              </div>
            </div>
            <div className="ms-Grid-row">
              <div className="form-field ms-Grid-col ms-sm12 ms-md8 ms-lg3 ms-xl3">
                <div className="form-heading">{t("hospital.for-docx")}</div>
              </div>
              <div className="ms-Grid-col ms-sm12 ms-md6 ms-lg8 ms-xl8">
                {props.values.isDOCX == 1
                  ? t("confirm-message.yes")
                  : t("confirm-message.no")}
              </div>
            </div>
            <div className="ms-Grid-row">
              <div className="form-field ms-Grid-col ms-sm12 ms-md8 ms-lg3 ms-xl3">
                <div className="form-heading">
                  {t("hospital.for-docx-key-image")}
                </div>
              </div>
              <div className="ms-Grid-col ms-sm12 ms-md6 ms-lg8 ms-xl8">
                {props.values.isDOCXWithKeyImage == 1
                  ? t("confirm-message.yes")
                  : t("confirm-message.no")}
              </div>
            </div>
            <div className="ms-Grid-row">
              <div className="form-field ms-Grid-col ms-sm12 ms-md8 ms-lg3 ms-xl3">
                <div className="form-heading">{t("hospital.for-pdf")}</div>
              </div>
              <div className="ms-Grid-col ms-sm12 ms-md6 ms-lg8 ms-xl8">
                {props.values.isPDF == 1
                  ? t("confirm-message.yes")
                  : t("confirm-message.no")}
              </div>
            </div>
            <div className="ms-Grid-row">
              <div className="form-field ms-Grid-col ms-sm12 ms-md8 ms-lg3 ms-xl3">
                <div className="form-heading">
                  {t("hospital.for-pdf-image")}
                </div>
              </div>
              <div className="ms-Grid-col ms-sm12 ms-md6 ms-lg8 ms-xl8">
                {props.values.isPDFWithImage == 1
                  ? t("confirm-message.yes")
                  : t("confirm-message.no")}
              </div>
            </div>
            <div className="ms-Grid-row">
              <div className="form-field ms-Grid-col ms-sm12 ms-md8 ms-lg3 ms-xl3">
                <div className="form-heading">
                  {t("hospital.for-pdf-key-image")}
                </div>
              </div>
              <div className="ms-Grid-col ms-sm12 ms-md6 ms-lg8 ms-xl8">
                {props.values.isPDFWithKeyImage == 1
                  ? t("confirm-message.yes")
                  : t("confirm-message.no")}
              </div>
            </div>
          </div>
          <HeaderFooterImage
            headerName={t("hospital.header-footer-image")}
            values={props.values}
            headerImageValue={props.headerImageValue}
            footerImageValue={props.footerImageValue}
            state={props.state}
            ownFirm={props.ownFirm}
            editConfigurationSetting={props.editConfigurationSetting}
            action={props.action}
          />
          {(props.values.isFirmPacsReceiver || props.values.isFirmPacsReceiver == "true" || process.env.REACT_APP_VDC_PLATFORM == "true") && <>
          <div className="ms-Grid" dir="ltr" style={{marginTop: "10px"}}>
            <div className="ms-Grid-row">
              <div className="form-field ms-Grid-col ms-sm12 ms-md8 ms-lg3 ms-xl3">
                <div
                  className="headerImageContainer"
                  style={{ display: "flex", flexDirection: "column" }}
                >
                  <label>Custom Header Address Line 1: </label>
                </div>
              </div>
              <div className="ms-Grid-col ms-sm12 ms-md6 ms-lg8 ms-xl8">
                {props.values.headerTextLine1 == "" ? "-" : props.values.headerTextLine1}
              </div>
            </div>
          </div>
          <div className="ms-Grid" dir="ltr" style={{marginTop: "10px"}}>
            <div className="ms-Grid-row">
              <div className="form-field ms-Grid-col ms-sm12 ms-md8 ms-lg3 ms-xl3">
                <div
                  className="headerImageContainer"
                  style={{ display: "flex", flexDirection: "column" }}
                >
                  <label>Custom Header Address Line 2: </label>
                </div>
              </div>
              <div className="ms-Grid-col ms-sm12 ms-md6 ms-lg8 ms-xl8">
                {props.values.headerTextLine2 == "" ? "-" : props.values.headerTextLine2}
              </div>
            </div>
          </div>
          </>}
          <div className="ms-Grid" dir="ltr" style={{marginTop: "10px"}}>
            <div className="ms-Grid-row">
              <div className="form-field ms-Grid-col ms-sm12 ms-md8 ms-lg3 ms-xl3">
                <div
                  className="headerImageContainer"
                  style={{ display: "flex", flexDirection: "column" }}
                >
                  <label>No. of Blank Lines Required After Header Image</label>
                </div>
              </div>
              <div className="ms-Grid-col ms-sm12 ms-md6 ms-lg8 ms-xl8">
                {props.values.reqBlankLines}
              </div>
              
            </div>
            <div className="ms-Grid-row">
              <div className="form-field ms-Grid-col ms-sm12 ms-md8 ms-lg3 ms-xl3">
                <div
                  className="headerImageContainer"
                  style={{ display: "flex", flexDirection: "column" }}
                >
                  <label>No. of Blank Lines Required After Header Report Template</label>
                </div>
              </div>
              <div className="ms-Grid-col ms-sm12 ms-md6 ms-lg8 ms-xl8">
                {props.values.reqBlankLinesAfterHeader}
              </div>
              
            </div>
          </div>
        </div>
      )}
    </>
  );
};

export default HeaderFileCheck;
